import React, { useEffect, useState } from 'react';
import './Comments.css';
import "bootstrap/dist/css/bootstrap.min.css";

const CommentItem = ({ userName, comment, time }) => (
  <div className="comment-container">
    <div className="avatar">👤</div>
    <div className="comment-content">
      <h4 className="user-name">{userName}</h4>
      <p className="comment-text">{comment}</p>
      <p className="comment-time">{time}</p>
    </div>
  </div>
);

const Comments = () => {
  const [comments, setComments] = useState([]);

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const response = await fetch('http://localhost:5000/api/suggestions'); // Adjust your API endpoint if needed
        const data = await response.json();
        const formattedComments = data.docs.map(comment => ({
          id: comment._id,
          userName: comment.user.name,
          comment: comment.content,
          time: new Date(comment.createdAt).toLocaleString(), // Format date as needed
        }));
        setComments(formattedComments);
      } catch (error) {
        console.error("Error fetching comments:", error);
      }
    };

    fetchComments();
  }, []);

  return (
    <div className="comments-section">
      <h2 className='mt-3 text-align-center'>Comments</h2>
      {comments.length > 0 ? (
        comments.map(item => (
          <CommentItem 
            className="mt-2"
            key={item.id} 
            userName={item.userName} 
            comment={item.comment} 
            time={item.time} 
          />
        ))
      ) : (
        <p>No comments available</p>
      )}
    </div>
  );
};

export default Comments;